import {IAltitude, IPolygon} from '../../utm';
import {TransportGeoCircle, TransportRadius} from "./circle";

/**
 * UTM models
 * This file contains the core UTM models as OpenAPI 2.0 compliant definitions. Some key caveats when using/referencing
 * this API:
 *  1. The API on its own is insufficient to develop a USS or other UTM component. For example, the USS Specification is
 *      needed to understand how and when to use the various endpoints and provides more details on security features
 *      that cannot be captured in the API docs.
 *  2. There is not a unified time synchronization approach in UTM currently. As such, times provided from one server
 *      MUST NOT be validated against each other. For example, if a sending server states that a data element was sent
 *      at 10:00:23, but the receiving server thinks it is currently 10:00:22, the receiving server must not reject the
 *      data submission. As we develop and roll out the time synchronization scheme for the USS Network, we will add
 *      appropriate validation requirements to the API documentation.
 *  3. On the contrary, times must be validated for consistency within a given data submission. For example, if a server
 *      states that it sends a data instance at 10:00:23 and one of the other data elements states that a measurement
 *      was performed at 10:00:24, then the receiving server must reject that data submission. Some of these checks are
 *      explictly stated in the descriptions below. If you recognize any such checks that are not documented, please
 *      submit an issue report on github.
 *  4. These token SUBJECT validations are required for security. For PUT Operation to modify an existing operation, the
 *      token SUBJECT claim upon modification MUST equal the token SUBJECT claim for the initial Operation. For PUT
 *      Message associated with an Operation gufi, the token SUBJECT claim used for PUT Message MUST equal the token
 *      SUBJECT claim for the initial operation. This check is performed if the initial operation exists, so as to not
 *      preclude receiving emergency messages. For PUT Position associated with an Operation gufi, the token SUBJECT
 *      claim used for PUT Position MUST equal the token SUBJECT claim for the initial operation. This check is
 *      performed only if the initial operation exists, so as to not preclude receiving emergency position reports.
 *
 * The version of the OpenAPI document: v4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface IEntityVolume4d {
  /**
   * Earliest time the constraint will use this constraint volume. It must be less than effectiveTimeEnd.
   * The following MUST hold: effectiveTimeBegin < effectiveTimeEnd MUST be true.
   */
  effective_time_begin: string;

  /**
   * Latest time the constraint will use this constraint volume. It must be greater than effectiveTimeBegin.
   * The following MUST hold: effectiveTimeBegin < effectiveTimeEnd MUST be true.
   */
  effective_time_end: string;

  /**
   * The minimum altitude for this constraint volume.
   * Note that min and max values are added as a sanity check. As use cases evolve and more options are made available
   * in terms of units of measure or reference systems, these bounds should be re-evaluated.
   * The following MUST hold: min_altitude.altitude_value < max_altitude.altitude_value
   */
  min_altitude: IAltitude;

  /**
   * The maximum altitude for this constraint volume.
   * Note that min and max values are added as a sanity check. As use cases evolve and more options are made available
   * in terms of units of measure or reference systems, these bounds should be re-evaluated.
   * The following MUST hold: min_altitude.altitude_value < max_altitude.altitude_value
   */
  max_altitude: IAltitude;

  /**
   * The minimum altitude for this constraint volume, using the originally supplied vertical reference and unit of measure.
   * Note that min and max values are added as a sanity check. As use cases evolve and more options are made available
   * in terms of units of measure or reference systems, these bounds should be re-evaluated.
   * The following MUST hold: submitted_min_altitude.altitude_value < submitted_max_altitude.altitude_value
   */
  submitted_min_altitude?: IAltitude;

  /**
   * The maximum altitude for this constraint volume, using the originally supplied vertical reference and unit of measure.
   * Note that min and max values are added as a sanity check. As use cases evolve and more options are made available
   * in terms of units of measure or reference systems, these bounds should be re-evaluated.
   * The following MUST hold: submitted_min_altitude.altitude_value < submitted_max_altitude.altitude_value
   */
  submitted_max_altitude?: IAltitude;

  geography: IPolygon;

  /**
   * A circular geometry consisting of a center pair of lat/lon coordinates and a radius in meters.
   */
  circle: TransportGeoCircle;

  /**
   * User submitted radius value with units of measure
   */
  submitted_radius?: TransportRadius;
}

export namespace IEntityVolume4d {
  export type VerticalReferenceEnum = 'W84';
  export const VerticalReferenceEnum = {
    W84: 'W84' as VerticalReferenceEnum
  };
  export type UnitsOfMeasureEnum = 'FT';
  export const UnitsOfMeasureEnum = {
    FT: 'FT' as UnitsOfMeasureEnum
  };
  export type SourceEnum = 'ONBOARD_SENSOR' | 'OTHER';
  export const SourceEnum = {
    ONBOARDSENSOR: 'ONBOARD_SENSOR' as SourceEnum,
    OTHER: 'OTHER' as SourceEnum
  };
}


